import React, { memo }  from 'react';
import IconWrapper from './IconWrapper';

const IconLock = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#e53d46"} className={`lock ${props.className}`} viewBox="2 1 14 16">
        <path d="M13.5,6.375 L12.75,6.375 L12.75,4.875 C12.75,2.805 11.07,1.125 9,1.125 C6.93,1.125 5.25,2.805 5.25,4.875 L5.25,6.375 L4.5,6.375 C3.675,6.375 3,7.05 3,7.875 L3,15.375 C3,16.2 3.675,16.875 4.5,16.875 L13.5,16.875 C14.325,16.875 15,16.2 15,15.375 L15,7.875 C15,7.05 14.325,6.375 13.5,6.375 Z M6.75,4.875 C6.75,3.63 7.755,2.625 9,2.625 C10.245,2.625 11.25,3.63 11.25,4.875 L11.25,6.375 L6.75,6.375 L6.75,4.875 Z M13.5,15.375 L4.5,15.375 L4.5,7.875 L13.5,7.875 L13.5,15.375 Z M9,13.125 C9.825,13.125 10.5,12.45 10.5,11.625 C10.5,10.8 9.825,10.125 9,10.125 C8.175,10.125 7.5,10.8 7.5,11.625 C7.5,12.45 8.175,13.125 9,13.125 Z"></path>
    </IconWrapper>
);


export default memo(IconLock);
